module.exports = __webpack_public_path__ + "static/img/btc_btn.2a77c35.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/btc_btn.png
// module id = czkc
// module chunks = 51